<template>
  <div>
    <common-dialog
      ref="dialog"
      title="Release Pallets"
      :inputs-map="inputsMap"
      :input-value-change="valueChange"
      :save-cb="save"
      :width="50"
      :reset-inputs="resetInputs"
    >
      <template v-slot:buttons>
        <el-button plain type="primary" size="mini" @click="openNewAddress">
          + New Address
        </el-button>
      </template>
    </common-dialog>
    <address-new ref="addressNew" />
  </div>
</template>
<script>
// others
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
// models
import { PalletsReleaseForm } from '@/core/models/pallet'
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
import AddressNew from '@/components/address/AddressNew.vue'
// api
import { modifyPallet } from '@/api/pallet'
// msg
import PagesMessage from '@/core/message/pages'
import { diffOfTwoObject } from '@/core/utils/common'
export default {
  name: 'PalletsRelease',
  mixins: [dialogMixin],
  components: {
    CommonDialog,
    AddressNew
  },
  props: {},
  data() {
    return {
      inputsMap: cloneDeep(Object.values(PalletsReleaseForm)),
      originPallet: null,
      palletId: '',
      pallets: []
    }
  },
  methods: {
    save(info, done, error) {
      let diffs = diffOfTwoObject(info, this.originPallet)
      diffs = Object.fromEntries(diffs.map(one => [one.key, one.newValue]))
      if ('address' in diffs) {
        diffs.addressId = diffs.address?.id ?? undefined
      }

      if (!isEmpty(diffs)) {
        const promises = []
        for (const pallet of this.pallets) {
          const promise = modifyPallet(pallet.id, diffs)
          promises.push(promise)
        }
        Promise.all(promises).then(() => {
          this.$message.success('Release pallets successfully!')
          this.close()
          done()
          PagesMessage.emit(PagesMessage.eventMap.REFRESH_STOCK_PAGE)
        })
      } else {
        this.$message.error('Please make changes!')
      }
    },
    open(pallets) {
      this.$refs.dialog.open()
      this.$set(this, 'pallets', pallets)
      const address = pallets[0].address
      this.$set(this.inputsMap[0], 'value', 'True')
      this.$set(this.inputsMap[1], 'value', address)
      this.originPallet = { hold: 'True', address }
    },
    close() {
      this.$refs.dialog.close()
    },
    resetInputs() {
      this.inputsMap.forEach(one => {
        one.value = get(this.originPallet, one.key, '')
      })
    },
    openNewAddress() {
      this.$refs.addressNew.open(null, newAddress => {
        const addressInput = this.inputsMap.find(one => one.key === 'address')
        if (addressInput) this.$set(addressInput, 'value', newAddress)
      })
    },
    valueChange() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
